import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import messaging from "../../services/messagingv2.js";

class PajtooltipController {
  constructor($http, $localStorage, $state, AuthService, SecurityService, Messagingv2Service, $rootScope, $location, TrackingService, $timeout) {
    this.name = "jobblefooter";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$tracking = TrackingService;
    this.$security = SecurityService;
    this.$messagingv2 = Messagingv2Service;
    this.currentUser = this.$auth.getUserData();
    this.$location = $location;
    this.loadLocalLytics = false;
    this.$timeout = $timeout;
    this.counter = 0;

    this.$timeout(() => {
      this.enableToolTips();
    }, 250);
  }

  enableToolTips() {
    this.$timeout(() => {
      $(".paj-tooltip").tooltip({}); //.tooltip('dispose');
    }, 200);
  }

  scrollToToolTip() {
    try {
      $("#paj-main-scroll").animate({scrollTop: 999}, 400);
      // document.getElementById("paj-main-scroll").scrollTop = 9999;
    } catch (e) {}
  }
}

PajtooltipController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "messagingv2",
  "$rootScope",
  "$location",
  "tracking",
  "$timeout",
];

export default PajtooltipController;



// WEBPACK FOOTER //
// ./client/app/common/pajtooltip/pajtooltip.controller.js